module.exports = __webpack_public_path__ + "img/LOGO-7.9ea76089.png";